const baseURL = 'participant';

export interface IParticipantPageParameter {
	contentId: number|string;
	questionGroupId: number|string;
	wfItemId: number|string;
	pageUrl: string;
	viewMode: string;
}

export const participantPages = {
	root: { base: (): string => { return '';}, url: baseURL },

	dashboard: { base: (): string => { return `/${baseURL}`; }, url: '' },
	workflowDashboard: { base: (): string => { return `/${baseURL}/workflow-list`; }, url: 'workflow-list' },
	create: { base: (): string => { return `/${baseURL}/create`; }, url: 'create' },
	edit: { base: (): string => { return `/${baseURL}/edit`; }, url: 'edit' },
	// eslint-disable-next-line no-empty-pattern
	stammDaten: { base: ({}: Partial<IParticipantPageParameter> = {}): string => { return `/${baseURL}/info`; }, url: 'info' },

	workflow: { base: (): string => { return `/${baseURL}/workflow`; }, url: 'workflow' },
	workflowDetails: {
		base: ({wfItemId}: Partial<IParticipantPageParameter>): string =>
		{ return `/${baseURL}/workflow/details/${wfItemId}`; },
		url: 'workflow/details/:itemId'
	},
	workflowOverview: {
		base: ({wfItemId, viewMode = ''}: Partial<IParticipantPageParameter>): string =>
		{ return `/${baseURL}/workflow/overview/${wfItemId}/${viewMode}`; },
		url: 'workflow/overview/:itemId/:viewMode'
	},
	workflowProcess: {
		base: ({wfItemId, pageUrl = ''}: Partial<IParticipantPageParameter>): string =>
		{ return `/${baseURL}/workflow/run/${wfItemId}/${pageUrl}`; },
		url: 'workflow/run/:itemId'
	},
	workflowProcessQuestionGroup: {
		base: ({wfItemId, questionGroupId = ''}: Partial<IParticipantPageParameter>): string =>
		{ return `/${baseURL}/workflow/run/${wfItemId}/${questionGroupId}`; },
	},
	workflowProcessContentItem: {
		base: ({wfItemId, questionGroupId = 0, contentId = 0}: Partial<IParticipantPageParameter>): string =>
		{ return `/${baseURL}/workflow/run/${wfItemId}/${questionGroupId}/i/${contentId}`; },
	},
	workflowRandomizationItem: {
		base: ({wfItemId}: Partial<IParticipantPageParameter>): string =>
		{ return `/${baseURL}/workflow/randomization/${wfItemId}`; },
		url: 'workflow/randomization/:itemId'
	},
};
